import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_FamilyNeedsAssessment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_FamilyNeedsAssessment' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <h2><center> Family Need Assesmnt </center></h2>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            Texas Health and Human Services Case Management For Children and Pregnant Women
                        </td>
                        <td className='w-425'>
                        </td>
                        <td className='w-75'>
                        CM-02 Aug 2022
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                           <b> SITE OF ASSESSMENT:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHome' name='cbHome' className='add-only' value='Home' /> HOME </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbClinic' name='cbClinic' className='add-only' value='Clinic' /> CLINIC </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherSpecify' name='cbOtherSpecify' className='add-only' value='OtherSpecify' /> OTHER, SPECIFY
                            &nbsp;
                            <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-280'>
                            <span className='eleHeader'>NAME:</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOB</span>
                        </td>
                        &nbsp;&nbsp;
                        <td className='w-280'>
                            <span className='eleHeader'>MEDICAID NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>
                        <td className='w-280'>
                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> IS THIS A MIGRANT FAMILY?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750' >
                            <input type='radio' id='rbYesIfYesMustComplete' name='rbIsThisMigrant' className='add-only' value='YesIfYesMustComplete' /> YES (IF YES, MUST COMPLETE CPW-02A)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbNo' name='rbIsThisMigrant' className='add-only' value='No' /> NO
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            Indicate other household members receiving case management services with an asterisk (*).
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <span className='eleHeader'>NAMES OF HOUSEHOLD MEMBERS</span>
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>RELATIONSHIP TO CLIENT</span>
                        </td>
                        <td className='w-75'>
                            <span className='eleHeader'>AGE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_1' name='txtNameOfHouseholdMembers_1' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_1' name='txtRelationshipToClient_1' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_1' name='txtAge_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_2' name='txtNameOfHouseholdMembers_2' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_2' name='txtRelationshipToClient_2' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_2' name='txtAge_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_3' name='txtNameOfHouseholdMembers_3' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_3' name='txtRelationshipToClient_3' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_3' name='txtAge_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_4' name='txtNameOfHouseholdMembers_4' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_4' name='txtRelationshipToClient_4' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_4' name='txtAge_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_5' name='txtNameOfHouseholdMembers_5' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_5' name='txtRelationshipToClient_5' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_5' name='txtAge_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_6' name='txtNameOfHouseholdMembers_6' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_6' name='txtRelationshipToClient_6' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_6' name='txtAge_6' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_7' name='txtNameOfHouseholdMembers_7' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_7' name='txtRelationshipToClient_7' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_7' name='txtAge_7' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-325'>
                            <input type='text' id='txtNameOfHouseholdMembers_8' name='txtNameOfHouseholdMembers_8' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <input type='text' id='txtRelationshipToClient_8' name='txtRelationshipToClient_8' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAge_8' name='txtAge_8' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h2> <center>CLIENT INFORMATION</center></h2>
                </p>
                <p className='w-750'>
                    <b>MEDICAL AND OTHER SERVICES </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <b> PCP/MEDICAL HOME</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>IMMUNIZATIONS:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>TEXAS HEALTH STEPS/WELL-CHILD EXAMS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>CURRENT:&nbsp;
                            <input type='radio' id='Yes' name='rbImmunizations' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbImmunizations' className='add-only' value='No' /> NO
                        </td>
                        <td className='w-375'>CURRENT:&nbsp;
                            <input type='radio' id='Yes' name='rbTexasHealthSteps' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbTexasHealthSteps' className='add-only' value='No' /> NO
                        </td>

                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider' name='txtDocumentNameOfProvider' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds' name='cbCheckIfNeeds' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>OBSTETRICIAN:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DUE DATE:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>EXAMS CURRENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only w-150 custom add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='Yes' name='rbExamsCurrent' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbExamsCurrent' className='add-only' value='No' />  NO
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_1' name='txtDocumentNameOfProvider_1' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_1' name='cbCheckIfNeeds_1' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p>
                    <b>PHYSICIANS OTHER THAN PCP: </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_2' name='txtDocumentNameOfProvider_2' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_2' name='cbCheckIfNeeds_2' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p>
                    <b>DENTIST:</b>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>EXAMS CURRENT</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='Yes' name='rbExamsCurrent_1' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbExamsCurrent_1' className='add-only' value='No' />  NO
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_3' name='txtDocumentNameOfProvider_3' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_3' name='cbCheckIfNeeds_3' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>HOME HEALTH PROVIDERS (ATTENDANT CARE, THERAPY, NURSING):</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_4' name='txtDocumentNameOfProvider_4' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_4' name='cbCheckIfNeeds_4' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>
                        LOCAL INTELLECTUAL AND DEVELOPMENTAL DISABILIT AUTHORITY (LIDDA):
                    </b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>IS THE CHILD ON A MEDICAI WAIVER PROGRAM? (CLASS, DBMD, HCS, TXHML, MDCP)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='Yes' name='rbIsTheChildOnMedicaiWaiver' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbIsTheChildOnMedicaiWaiver' className='add-only' value='No' />  NO
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_5' name='txtDocumentNameOfProvider_5' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_5' name='cbCheckIfNeeds_5' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MEDICAL/ADAPTIVE EQUIPMENT SUPPLIES/NUTRITIONAL SUPPLEMENTS</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_6' name='txtDocumentNameOfProvider_6' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_6' name='cbCheckIfNeeds_6' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>MANAGED CARE ORGANIZATION (MCO) /OTHER MEDICAL INSURANCE:</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_7' name='txtDocumentNameOfProvider_7' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_7' name='cbCheckIfNeeds_7' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SUPPLEMENTAL SECURITY INSURANCE (SSI)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='Yes' name='rbSupplementalSecurityInsurance' className='add-only' value='Yes' /> YES&nbsp;
                            <input type='radio' id='No' name='rbSupplementalSecurityInsurance' className='add-only' value='No' />  NO
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_8' name='txtDocumentNameOfProvider_8' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_8' name='cbCheckIfNeeds_8' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>OTHER SERVICES:</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT NAME OF PROVIDER AND CURRENT STATUS</span>
                    <textarea id='txtDocumentNameOfProvider_9' name='txtDocumentNameOfProvider_9' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_9' name='cbCheckIfNeeds_9' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>HEALTH STATUS - CLIENT</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>DESCRIBE HEALTH CONDITION, HEALTH RISK OR HIGH-RISK CONDITION.</span>
                    < span className='small w-750'>LIST ANY DIAGNOSIS, IF APPLICABLE.</span>
                    <textarea id='txtDescribeHealthCondition' name='txtDescribeHealthCondition' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_10' name='cbCheckIfNeeds_10' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> MEDICATIONS:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_1' name='cbNone_1' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtMedication' name='txtMedication' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_11' name='cbCheckIfNeeds_11' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>DEVELOPMENTAL - CLIENT</b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>MOTOR SKILLS (FINE AND GROSS):</span>
                    <textarea id='txtMotorSkills' name='txtMotorSkills' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_12' name='cbCheckIfNeeds_12' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>VISION:</span>
                    <textarea id='txtVision' name='txtVision' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_13' name='cbCheckIfNeeds_13' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>SPEECH/LANGUAGE:</span>
                    <textarea id='txtSpeechLanguage' name='txtSpeechLanguage' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_14' name='cbCheckIfNeeds_14' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>HEARING:</span>
                    <textarea id='txtHearing' name='txtHearing' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_15' name='cbCheckIfNeeds_15' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>SELF-HELP SKILLS FEEDING/DRESSING/OTHER ACTIVIITES OF DAILY LIVING </span>
                    <textarea id='txtSelfHelpSkills' name='txtSelfHelpSkills' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_16' name='cbCheckIfNeeds_16' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>MENTAL HEALTH/BEHAVIORAL/SOCIAL SKILLS </span>
                    <textarea id='txtMentalHealthBehavioralSocialSkills' name='txtMentalHealthBehavioralSocialSkills' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_17' name='cbCheckIfNeeds_17' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>TRANSITION PLANNING TO ADULTHOOD/GUARDIANSHIP </span>
                    <textarea id='txtTransitionPlanningToAdulthood' name='txtTransitionPlanningToAdulthood' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_18' name='cbCheckIfNeeds_18' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EDUCATIONAL/VOCATIONAL - CLIENT </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEci' name='cbEci' className='add-only' value='Eci' /> ECI
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHeadStart' name='cbHeadStart' className='add-only' value='HeadStart' /> HEAD START
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSchoolPpcd' name='cbSchoolPpcd' className='add-only' value='SchoolPpcd' /> SCHOOL (PPCD-12)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSpecialEducation' name='cbSpecialEducation' className='add-only' value='SpecialEducation' /> SPECIAL EDUCATION/ 504
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbVocationalTradeCollTradeCollege' name='cbVocationalTradeCollTradeCollege' className='add-only' value='VocationalTradeCollTradeCollege' /> VOCATIONAL/TRADE/COLLEGE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>DOCUMENT AGENCY/SCHOOL ATTENDING /CURRENT ISSUES </span>
                    <textarea id='txtDocumentAgencySchoolAttendingCurrentIssues' name='txtDocumentAgencySchoolAttendingCurrentIssues' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_19' name='cbCheckIfNeeds_19' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>FAMILY INFORMATION</b>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MEDICAL: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_2' name='cbNone_2' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtMedical' name='txtMedical' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_20' name='cbCheckIfNeeds_20' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DENTAL: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_3' name='cbNone_3' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtDental' name='txtDental' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_21' name='cbCheckIfNeeds_21' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MENTAL HEALTH/COUNSELING: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_4' name='cbNone_4' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtMentalHealthCounseling' name='txtMentalHealthCounseling' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_22' name='cbCheckIfNeeds_22' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EMPLOYMENT/FINANCIAL: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_5' name='cbNone_5' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtEmploymentFinancial' name='txtEmploymentFinancial' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_23' name='cbCheckIfNeeds_23' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>UTILITIES: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_6' name='cbNone_6' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtUtilities' name='txtUtilities' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_24' name='cbCheckIfNeeds_24' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>FOOD: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_7' name='cbNone_7' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtFood' name='txtFood' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_25' name='cbCheckIfNeeds_25' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>HOUSING/ACCESSIBLITY: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_8' name='cbNone_8' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtHousingAccessibility' name='txtHousingAccessibility' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_26' name='cbCheckIfNeeds_26' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EMERGENCY/DISASTER PLAN: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_9' name='cbNone_9' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtEmergencyDisasterPlan' name='txtEmergencyDisasterPlan' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_27' name='cbCheckIfNeeds_27' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TRANSPORTATION: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_10' name='cbNone_10' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtTransportation' name='txtTransportation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_28' name='cbCheckIfNeeds_28' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>LEGAL ISSUES/CHILD SUPPORT: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_11' name='cbNone_11' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtLegalIssuesChildSupport' name='txtLegalIssuesChildSupport' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_29' name='cbCheckIfNeeds_29' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PARENTING SUPPORT: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_12' name='cbNone_12' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtParentingSupport' name='txtParentingSupport' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_30' name='cbCheckIfNeeds_30' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EDUCATION: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_13' name='cbNone_13' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtEducation' name='txtEducation' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_31' name='cbCheckIfNeeds_31' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>COMMUNITY/FAMILY SUPPORT SYSTEMS/CULTURAL ISSUES: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_14' name='cbNone_14' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtCommunityFamilySupportSystemsCulturalIssues' name='txtCommunityFamilySupportSystemsCulturalIssues' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_32' name='cbCheckIfNeeds_32' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CHILDCARE/RESPITE CARE: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_15' name='cbNone_15' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtChildcareRespiteCare' name='txtChildcareRespiteCare' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_33' name='cbCheckIfNeeds_33' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>FAMILY VIOLENCE: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_16' name='cbNone_16' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtFamilyViolence' name='txtFamilyViolence' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_34' name='cbCheckIfNeeds_34' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SUBSTANCE ABUSE: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_17' name='cbNone_17' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtSubstanceAbuse' name='txtSubstanceAbuse' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_35' name='cbCheckIfNeeds_35' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CHILD PROTECTIVE (CPS)/ADULT PROTECTIVE SERVICES (APS): </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_18' name='cbNone_18' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtChildProtectiveCpsAdultProtective' name='txtChildProtectiveCpsAdultProtective' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_36' name='cbCheckIfNeeds_36' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>OTHER PSYCHOSOCIAL CONCERNS: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNone_19' name='cbNone_19' className='add-only' value='None' /> NONE
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id='txtOtherPsychosocialConcerns' name='txtOtherPsychosocialConcerns' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCheckIfNeeds_37' name='cbCheckIfNeeds_37' className='add-only' value='CheckIfNeeds' /> Check if Needs Assistance/Enter Need on SP
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                <span className='eleHeader'>ADDITIONAL COMMENTS: </span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CASE MANAGER SIGNATURE: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CASE MANAGER PRINTED NAME:</td>
                    </tr>
                </table>

            </div>
        </form>
    )
}










